// removes the href
setTimeout(function () {
    var links = document.querySelectorAll('div.tabs ul[role="tablist"] li.nav-item');

    for (let i = 0; i < links.length; i++) {
        links[i].setAttribute('role', 'none');
    }
}, 1000);



// WEBPACK FOOTER //
// ./src/app/directives/tabs.js